import BlibliHisteriaImage from "../../../assets/images/projects/blibli-histeria/thumbnail.png";
import { ProjectDataProps } from "../props";

export default {
  title: "Blibli Histeria Dashboard",
  description: "Blibli’s Promo Gamification Dashboard Cashback",
  image: BlibliHisteriaImage,
  path: "/blibli-histeria",
} as ProjectDataProps;
